/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2FilterByFilterType = exports.SubdivisionType = exports.ServiceFilterByFilterType = exports.Proximity = exports.ProvidersNames = void 0;
var ProvidersNames;
(function (ProvidersNames) {
    ProvidersNames["Google"] = "Google";
    ProvidersNames["Apple"] = "Apple";
})(ProvidersNames = exports.ProvidersNames || (exports.ProvidersNames = {}));
var Proximity;
(function (Proximity) {
    Proximity["UNKNOWN_PROXIMITY"] = "UNKNOWN_PROXIMITY";
    Proximity["PINPOINT"] = "PINPOINT";
    Proximity["APPROXIMATE"] = "APPROXIMATE";
    Proximity["GENERAL_AREA"] = "GENERAL_AREA";
})(Proximity = exports.Proximity || (exports.Proximity = {}));
var ServiceFilterByFilterType;
(function (ServiceFilterByFilterType) {
    ServiceFilterByFilterType["zip_code"] = "zip_code";
    ServiceFilterByFilterType["country_code"] = "country_code";
})(ServiceFilterByFilterType = exports.ServiceFilterByFilterType || (exports.ServiceFilterByFilterType = {}));
var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType = exports.SubdivisionType || (exports.SubdivisionType = {}));
var V2FilterByFilterType;
(function (V2FilterByFilterType) {
    V2FilterByFilterType["zip_code"] = "zip_code";
    V2FilterByFilterType["country_code"] = "country_code";
})(V2FilterByFilterType = exports.V2FilterByFilterType || (exports.V2FilterByFilterType = {}));
//# sourceMappingURL=types.js.map